import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json' with { type: 'json' };
import ko from './locales/ko.json' with { type: 'json' };
import { MILLIS_PER_CREDIT } from '../utils/format.js';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: { translation: ko },
      en: { translation: en }
    },
    fallbackLng: 'ko',
    supportedLngs: ['ko', 'en'],
    interpolation: {
      escapeValue: false,
      // Service-api error `details` cross the wire in millicredits (the
      // storage unit), but every number this UI shows is credits. Converting
      // here — `{{consumed, credits}}` — keeps the API honest and stops each
      // catch site from having to pre-divide before it can translate.
      format: (value, format) =>
        format === 'credits' && typeof value === 'number' ? String(value / MILLIS_PER_CREDIT) : String(value)
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'veluga-admin-lang'
    }
  });

export default i18n;
